import type * as z from 'zod';

import { contactQueryLinkerSchema } from './contact-query-linker-schema';
import { contactQuerySchema } from './contact-query-schema';

export const contactLinkerWithPhoneNumberQuerySchema = contactQueryLinkerSchema.extend({
  phone_numbers: contactQuerySchema.shape.phone_numbers.optional(),
  emails: contactQuerySchema.shape.emails.nullish(),
});

export type ContactLinkerWithPhoneNumberQuerySchema = z.infer<typeof contactLinkerWithPhoneNumberQuerySchema>;
